import { NotFound } from "../../core/components/NotFound";
import { Route, Routes } from "react-router-dom";
import { ModuleNotFound } from "../../core/components/ModuleNotFound";
import { ChatbotNavigation } from "./ChatbotNavigation";
import { Chatbot } from "../features/chat/Chatbot";
import { WingmanAdmin } from "../features/admin/WingmanAdmin";
import { useHasAnyPermission } from "../../core/hooks/useHasAnyPermission";
import { UserPermissions } from "../../core/models/UserPermissions";

const ChatbotRoutes = () => {
  const hasWingmanAdmin = useHasAnyPermission(UserPermissions.WingmanSourceAdmin);
  return (
    <Routes>
      <Route path="" element={<ChatbotNavigation />}>
        <Route path="chat" element={<Chatbot />} />
        {hasWingmanAdmin && <Route path="admin" element={<WingmanAdmin />} />}
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="*" element={<ModuleNotFound />} />
    </Routes>
  );
};

export default ChatbotRoutes;